import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import CSSclasses from './cart-boxes-special-products-warning.scss';
const styles = {
  paper: CSSclasses.paper,
  root: CSSclasses.root
};
class CartBoxesSpecialProductsWarning extends React.Component {
  render() {
    const {
      open,
      onClose,
      title,
      contentText
    } = this.props;
    return /*#__PURE__*/React.createElement(PopupDialog, {
      open: open,
      onClose: onClose,
      title: /*#__PURE__*/React.createElement("div", {
        className: CSSclasses.title
      }, title),
      classes: styles,
      dataPopup: "CartBoxesSpecialProductsWarning",
      contentClass: CSSclasses.contentClass,
      content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: CSSclasses.header
      }, contentText), /*#__PURE__*/React.createElement("div", {
        className: CSSclasses.buttonWrapper
      }, /*#__PURE__*/React.createElement(Button, {
        dataButton: "Proceed",
        className: CSSclasses.button,
        type: "starter",
        size: "long",
        onClick: onClose
      }, "Close")))
    });
  }
}
export default CartBoxesSpecialProductsWarning;